export const htmlMessageWrapperId = 'pmp-html-message-wrapper';
